import { render, staticRenderFns } from "./NoteForm.vue?vue&type=template&id=fe240180&"
import script from "./NoteForm.vue?vue&type=script&lang=ts&"
export * from "./NoteForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports